import { ArrowRightOutlined } from '@ant-design/icons';
import { Card, Col, Divider, Row, Space } from 'antd';
import TaskInfo, { TaskInfoProps } from 'components/TaskInfo';
import { Link } from 'react-router-dom';
import { PipeReview } from 'types/common';
import { renderDate, renderLocation } from 'utils/helpers';
import StatusTag from 'components/StatusTag';
import {
  getGroupedPictures,
  getPipePictureList,
  getPipeStatus,
  getReason,
} from '../helper';
import Accordion from 'components/Accordion';
import CustomFileList from 'components/CustomFileList';
import { PIPE_REVIEW_STATUS } from 'utils/constants';

const Info = (props: TaskInfoProps) =>
  TaskInfo({ wrapperClass: 'p-0', ...props });

const PipeDetailContent = ({ data }: { data: PipeReview }) => {
  const { rejectedPictures } = getPipePictureList(data);

  const groupedRejectedPictures = getGroupedPictures(rejectedPictures);

  return (
    <Space direction="vertical">
      <Card>
        <Row gutter={[0, 24]}>
          <Col span={12}>
            <Info header="Submmitted Date" wrapperClass="p-0">
              {renderDate(data?.createdAt)}
            </Info>
          </Col>
          <Col span={12}>
            <Info header="Pipe Status">
              <StatusTag status={getPipeStatus(data)} />
            </Info>
          </Col>
          <Divider className="m-0" />
          <Col span={12}>
            <Info header="Pipe Name">{data?.name}</Info>
          </Col>
          <Col span={12}>
            <Info header="Task">{data?.dryingEventTaskName}</Info>
          </Col>
          <Col span={12}>
            <Info header="GPS">
              {renderLocation({ x: data?.location?.x, y: data?.location?.y })}
            </Info>
          </Col>
          <Col span={12}>
            <Info header="Farmer Associated">{data?.farmers?.[0]?.name}</Info>
          </Col>
          <Col span={12}>
            <Info header="Agronomist Name">{data?.agronomist?.name}</Info>
          </Col>
          <Col span={12}>
            <Info header="Agronomist Phone Number">
              {data?.agronomist?.phoneNumber}
            </Info>
          </Col>
          <Col span={12}>
            <Info header="Planting Group Name">{data?.season?.name}</Info>
          </Col>
          <Col span={24}>
            <Info header="Notes">{data?.notes}</Info>
          </Col>
          <Divider className="m-0" />

          {getPipeStatus(data) === PIPE_REVIEW_STATUS.REJECTED ||
          getPipeStatus(data) === PIPE_REVIEW_STATUS.APPROVED ? (
            <>
              <Col span={12}>
                <Info header="Reason">{getReason(data)}</Info>
              </Col>
              <Col span={12}>
                <Info header="Reviewed By">
                  {data?.documentList?.[0]?.reviewedBy}
                </Info>
              </Col>
              <Divider className="m-0" />
            </>
          ) : null}

          <Link
            target="_blank"
            to={{
              pathname: '/awd-progress',
              search: `seasonId=${data?.season?.id}&taskType=${data?.dryingEventTaskName}`,
            }}
          >
            Go to Task <ArrowRightOutlined />
          </Link>
        </Row>
      </Card>

      {groupedRejectedPictures?.length ? (
        <Accordion title="Rejected Pictures">
          <Row gutter={[0, 24]}>
            {groupedRejectedPictures?.map((pictures, index) => (
              <>
                <Col span={24}>
                  <Info header="Submitted Date">
                    {renderDate(pictures.date)}
                  </Info>
                </Col>
                <Col span={24}>
                  <Info header="Rejected Photos">
                    <CustomFileList images={pictures.urls ?? []} />
                  </Info>
                </Col>
                <Col span={12}>
                  <Info header="Reason">{pictures?.reason}</Info>
                </Col>
                <Col span={12}>
                  <Info header="Reviewed By">{pictures?.reviewedBy}</Info>
                </Col>
                {index < groupedRejectedPictures.length - 1 && (
                  <Divider className="m-0" />
                )}
              </>
            ))}
          </Row>
        </Accordion>
      ) : null}
    </Space>
  );
};

export default PipeDetailContent;
